






























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Gwequipment from "../../../store/entities/gwequipment";
class PagefactoryRequest{
  cId:Number;
  ftId:Number;
  wId:Number;
}
@Component
export default class EditGwequipments extends AbpBase {
  pagefactoryrequest: PagefactoryRequest = new PagefactoryRequest();
  @Prop({ type: Boolean, default: false }) value: boolean;
  created() {}
  gwequipment: Gwequipment = new Gwequipment();
  save() {
    (this.$refs.gwequipmentForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "gwequipment/update",
          data: this.gwequipment,
        });
        (this.$refs.gwequipmentForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  get factory(){
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.filterlist;
  }
   get floor() {
    return this.$store.state.floor.filterlist;
  }
  cancel() {
    (this.$refs.gwequipmentForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.gwequipment = Util.extend(true, {}, this.$store.state.gwequipment.editGwequipment);
      //console.log(this.gwequipment);
      this.selfactory(this.gwequipment.ftId);
      this.selwarehouse(this.gwequipment.wId);
    }
  }
   gwequipmentRule = {
    wId: [{type:"number",required: true, message: "请选择库房", trigger: "change" }],
    mac: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [{type:"number",required: true, message: "请选择楼层", trigger: "change" }],
    locationName: [{ required: true, message: "请填写位置", trigger: "blur" }],
    //number: [{transform: (value) => String(value), required: true, message: "请填写位置编号", trigger: "blur" }],
    iotCard: [{ required: true, message: "请填写物联网卡号", trigger: "blur" }],
    scope: [{ required: true, message: "请填写管辖范围", trigger: "blur" }]
    
  };
  selfactory(value:Number){
    this.pagefactoryrequest.ftId = value;
    this.getwarehouse();
      // this.getfloor();
  }
  selwarehouse(value:Number){
    this.pagefactoryrequest.wId = value;
    this.getfloor();
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getfilter",
      data: this.pagefactoryrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getfilter",
      data: this.pagefactoryrequest,
    });
  }
}
